export const API_ENDPOINTS = {
  PRODUCTS: '/products',
  PRODUCTS_BULAS: '/products/bulas',
  PRODUCT_VARIANT_GROUPS: '/product-variant-groups',
  PRODUCTS_PRICE: '/product-prices',
  PRODUCTS_CHARACTERISTICS: '/product-characteristics',
  PRODUCTS_CHARACTERISTICS_VALUES: '/product-characteristic-values',
  PRODUCTS_POPULAR: '/popular-products',
  PRODUCTS_REVIEWS: '/reviews',
  PRODUCTS_REVIEWS_ABUSE_REPORT: '/abusive_reports',
  PRODUCTS_QUESTIONS: '/questions',
  PRODUCT_AVAILABILITY_NOTIFICATIONS: '/product-availability-notifications',
  CHARACTERISTICS_GROUPS: '/characteristic-groups',
  CHARACTERISTICS: '/characteristics',
  FEEDBACK: '/feedbacks',
  CATEGORIES: '/categories',
  TYPES: '/types',
  TAGS: '/tags',
  SHOPS: '/shops',
  AUTHORS: '/authors',
  ADDRESSES: '/addresses',
  AUTHORS_TOP: '/top-authors',
  MANUFACTURERS: '/manufacturers',
  MANUFACTURERS_TOP: '/top-manufacturers',
  INSTITUTIONAL_PAGES: '/institutional-pages',
  COUPONS: '/coupons',
  COUPONS_VERIFY: '/coupons/verify',
  COUPONS_AVAILABLE: '/coupons/available',
  ORDERS: '/shop/orders',
  ORDER_REVIEWS: '/shop/orders',
  ORDER_INVOICES: '/shop/orders',
  ORDERS_SAVINGS_SUMMARY: '/shop/orders/savings-summary',
  ORDERS_PURCHASED_PRODUCTS: '/shop/orders/purchased-products',
  ORDER_STATUS: '/order-status',
  ORDER_ITEM_STATUS: '/order-item-status',
  ORDERS_TRACKING_NUMBER: '/orders/tracking-number',
  ORDERS_REFUNDS: '/refunds',
  ORDERS_PAYMENT: '/orders/payment',
  ORDERS_CHECKOUT_VERIFY: '/orders/checkout/verify',
  ORDERS_DOWNLOADS: '/downloads',
  GENERATE_DOWNLOADABLE_PRODUCT_LINK: '/downloads/digital_file',
  USERS: '/users',
  USERS_ADDRESS: '/users',
  USERS_ME: '/me',
  USERS_WALLET_MY: '/wallets/my',
  WALLET_ORDERS: '/wallets/orders',
  USERS_STATEMENTS: '/statements',
  USERS_LOGIN: '/auth/login',
  USERS_UPDATE_PROFILE: '/auth/update-profile',
  USERS_REGISTER: '/auth/register',
  USERS_RESET_PASSWORD_OPTIONS: '/auth/reset-password-options',
  USERS_FORGOT_PASSWORD: '/auth/send-reset-password',
  USERS_VERIFY_FORGOT_PASSWORD_TOKEN: '/auth/verify-forget-password-token',
  USERS_VALIDATE_RESET_TOKEN: '/auth/validate-reset-token',
  USERS_RESET_PASSWORD: '/auth/reset-password',
  USERS_CHANGE_PASSWORD: '/auth/change-password',
  USERS_LOGOUT: '/auth/logout',
  USERS_SUBSCRIBE_TO_NEWSLETTER: '/subscribe-to-newsletter',
  USERS_CONTACT_US: '/contact-us',
  USERS_WISHLIST: '/wishlists',
  USERS_RELATIONSHIPS: '/user-relationships',
  WISHLIST: '/wishlists',
  USERS_WISHLIST_TOGGLE: '/wishlists/toggle',
  SOCIAL_LOGIN: '/social-login-token',
  GOOGLE_MOBILE_LOGIN: '/auth/google/mobile',
  SEND_OTP_CODE: '/send-otp-code',
  VERIFY_OTP_CODE: '/verify-otp-code',
  OTP_LOGIN: '/otp-login',
  UPDATE_CONTACT: '/update-contact',
  SETTINGS: '/settings',
  PAYMENT_GATEWAYS: '/payment-gateways',
  GENERAL_SETTINGS: '/general-settings',
  PAYMENT_SETTINGS: '/payment-settings',
  UPLOADS: '/attachments',
  MY_QUESTIONS: '/my-questions',
  MY_REPORTS: '/my-reports',
  CARDS: '/credit-cards',
  SET_DEFAULT_CARD: '/set-default-card',
  SAVE_PAYMENT_METHOD: '/save-payment-method',
  PAYMENT_INTENT: '/payment-intent',
  BEST_SELLING_PRODUCTS: '/best-selling-products',
  SEND_VERIFICATION_EMAIL: '/email/verification-notification',
  USERS_UPDATE_EMAIL: '/update-email',
  STORE_NOTICES: 'store-notices',
  FAQS: '/faqs',
  NEAR_SHOPS: '/near-by-shop',
  REFUNDS_REASONS: 'refund-reasons',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  FLASH_SALE: 'flash-sale',
  PRODUCT_FLASH_SALE_INFO: 'product-flash-sale-info',
  REFUND_POLICIES: 'refund-policies',
  PRODUCTS_BY_FLASH_SALE: 'products-by-flash-sale',
  NOTIFY_LOGS: 'notify-logs',
  NOTIFICATIONS: '/notifications',
  NOTIFICATIONS_UNREAD_COUNT: '/notifications/unread-count',
  NOTIFICATIONS_READ_ALL: '/notifications/read-all',
  NOTIFICATIONS_STREAM: '/notifications/stream',
  STORE_NOTICES_IS_READ: 'store-notices/read',
  READ_ALL_NOTIFY_LOG: 'notify-log-read-all',
  READ_NOTIFY_LOG: 'notify-log-seen',
  BECAME_SELLER: 'became-seller',
  SHOP_MAINTENANCE_EVENT: 'shop-maintenance-event',
  USER_PROFILE_GENERATE_REFERRER_CODE: '/user-profile/generate-referrer-code',
  APPLE_MOBILE_LOGIN: '/auth/apple/mobile',
  EVENTS_TRACK: '/events/track',
  RECOMMENDATIONS_TRENDING: '/recommendations/trending',
  RECOMMENDATIONS_LAST_SEEN: '/recommendations/last-seen',
  RECOMMENDATIONS_FBT: '/recommendations/fbt',
  RECOMMENDATIONS_CAB: '/recommendations/cab',
  CART: '/cart',
  DELIVERY_PARTNERS: '/delivery-partners',
  DELIVERY_PARTNERS_FORM_OPTIONS: '/delivery-partners/form-options',
  // BFF
  SHIPPING_METHODS: '/quotation',
  PBM_VERIFY: '/pbm/verify',
  PBM_VERIFY_PRICES: '/pbm/verify-prices',
  PBM_ACTIVATE: '/pbm/activate',
  CART_VERIFY: '/pbm/cart-verify',
  PRESCRIPTION_ANALYSIS: '/shop/prescription-analysis',
  PRESCRIPTION_ANALYSIS_UPLOAD: '/shop/prescription-analysis/upload',
  ROULETTE_CONFIG: '/roulette/config',
  ROULETTE_STATUS: '/roulette/status',
  ROULETTE_SPIN: '/roulette/spin',
  ROULETTE_CLAIM: '/roulette/claim',
  ROULETTE_REMIND_ME: '/roulette/remind-me',
};
